import { useLayoutEffect, useRef, useState } from "react";

export function useMounted() {
  const [mounted, setMounted] = useState(false);
  useLayoutEffect(() => setMounted(true), []);
  return mounted;
}

// @ts-expect-error unused-export-debt
function useValue<T>(value: T) {
  const ref = useRef(value);
  return ref.current;
}
